
  /* tslint:disable */
  // This file was automatically generated and should not be edited.

  
export interface Query {

  employee: (params: {
  id : ID;}) => EmployeeNode
 
  allEmployees: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  name_Icontains ?: String;
  townid_Districtid_Stateid ?: ID;}) => EmployeeNodeConnection
 
  state: (params: {
  id : ID;}) => StateNode
 
  allStates: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  id_In ?: ID;
  name_Icontains ?: String;}) => StateNodeConnection
 
  town: (params: {
  id : ID;}) => TownNode
 
  allTowns: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  id_In ?: ID;
  name_Icontains ?: String;
  districtid_Stateid ?: ID;
  districtid_Stateid_Name_In ?: ID;// Ordering
  orderBy ?: String;}) => TownNodeConnection
 
  area: (params: {
  id : ID;}) => AreaNode
 
  allAreas: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  id_In ?: ID;
  name_Icontains ?: String;
  townid ?: ID;
  townid_Name_In ?: ID;}) => AreaNodeConnection
 
  retailer: (params: {
  id : ID;}) => RetailerNode
 
  allRetailers: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  firm_Icontains ?: String;
  townid ?: ID;
  areaid ?: ID;
  active ?: Boolean;}) => RetailerNodeConnection
 
  allProducts: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  name_Icontains ?: String;}) => ProductNodeConnection
 
  questionnaireStates: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  id_In ?: ID;
  name_Icontains ?: String;}) => QuestionnaireStateObjectConnection
 
  user: (params: {
  id : ID;}) => UserNode
 
  allUsers: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  username_Icontains ?: String;}) => UserNodeConnection
 
  userDetail: (params: {
  id : ID;}) => UserDetailNode
 
  allUserDetails: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  user_AuthToken ?: ID;
  user_Username_Icontains ?: ID;
  userType ?: String;
  userType_In ?: String;
  employee_Name_Icontains ?: ID;
  supervisorId ?: ID;
  dateRange ?: String;}) => UserDetailNodeConnection
 
  emailSetting: (params: {
  id : ID;}) => EmailSettingNode
 
  allEmailSettings: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  state ?: ID;
  isGlobal ?: Boolean;}) => EmailSettingNodeConnection
 
  callHistory: (params: {
  id : ID;}) => CallHistoryNode
 
  allCallHistorys: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  callStart_Gte ?: DateTime;
  callStart_Lte ?: DateTime;
  retailer_Firm_Icontains ?: ID;
  retailer_Id ?: ID;
  workHistory_Area ?: ID;
  workHistory_Work_State ?: ID;
  workHistory_Work_Caller ?: ID;
  town ?: String;}) => CallHistoryNodeConnection
 
  callResponse: (params: {
  id : ID;}) => CallResponseNode
 
  allCallResponses: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  call ?: ID;}) => CallResponseNodeConnection
 
  assignWork: (params: {
  id : ID;}) => AssignWorkNode
 
  allAssignWorks: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  supervisor ?: ID;
  caller ?: ID;
  caller_Employee_Name_Icontains ?: ID;}) => AssignWorkNodeConnection
 
  finishedFilterAssignWork: (params: {
  limit : Int;
  offset : Int;
  isFinished : Boolean;
  caller ?: ID;
  supervisor ?: ID;
  callerName ?: String;
  areas : Int[];
  towns : Int[];
  states : Int[];}) => null
 
  allWorkHistory: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  work_Caller ?: ID;
  onHold ?: Boolean;
  isActive ?: Boolean;}) => WorkHistoryNodeConnection
 
  pendingCallers: (params: {
  supervisorId : ID;}) => Int
 
  questionnaire: (params: {
  id : ID;}) => QuestionnaireNode
 
  allQuestionnaires: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  name_Icontains ?: String;
  id ?: ID;
  addedBy_Id ?: ID;
  state ?: ID;
  town ?: ID;
  state_Name_Icontains ?: ID;
  active ?: Boolean;
  stateTownFilter ?: String;}) => QuestionnaireNodeConnection
 
  question: (params: {
  id : ID;}) => QuestionNode
 
  allQuestions: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  addedBy_Id ?: ID;
  name_Icontains ?: String;}) => QuestionNodeConnection

}
 
export interface EmployeeNode {

  id: ID;
 
  name: String;
 
  photo?: String;
 
  address: String;
 
  pinCode: Int;
 
  personalmobilenumber?: String;
 
  companymobilenumber?: String;
 
  emailid?: String;
 
  bloodgroup?: String;
 
  callcode?: String;
 
  aadaharattachment?: String;
 
  aadaharnumber?: String;
 
  esicno?: String;
 
  dob: Date;
 
  cv?: String;
 
  emergencycontactmobilenumber?: String;
 
  emergencycontactname: String;
 
  emergencycontactrelation: String;
 
  panattachment?: String;
 
  pannumber?: String;
 
  bankaccountnumber?: String;
 
  bankname?: String;
 
  branch?: String;
 
  isfccode?: String;
 
  pfno?: String;
 
  townid: TownNode;
 
  headquartertownid?: TownNode;
 
  reportingmanagerid?: EmployeeNode;
 
  deviceid?: String;
 
  employeeSet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  name_Icontains ?: String;
  townid_Districtid_Stateid ?: ID;}) => null
 
  retailerSet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  firm_Icontains ?: String;
  townid ?: ID;
  areaid ?: ID;
  active ?: Boolean;}) => null
 
  userdetail?: UserDetailNode;
 
  emailsettingSet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  state ?: ID;
  isGlobal ?: Boolean;}) => null
 
  noOfWorksPending?: Int;
 
  startDateForNextWork?: Date;

}
  
export type ID = string;

   
export type String = string;

   
export type Int = number;

   
export type Date = string;

   
export interface TownNode {

  id: ID;
 
  name: String;
 
  districtid?: DistrictNode;
 
  areaSet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  id_In ?: ID;
  name_Icontains ?: String;
  townid ?: ID;
  townid_Name_In ?: ID;}) => null
 
  employeeSet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  name_Icontains ?: String;
  townid_Districtid_Stateid ?: ID;}) => null
 
  headquaterEmployee: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  name_Icontains ?: String;
  townid_Districtid_Stateid ?: ID;}) => null
 
  retailerSet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  firm_Icontains ?: String;
  townid ?: ID;
  areaid ?: ID;
  active ?: Boolean;}) => null
 
  questionnaireSet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;}) => null
 
  workhistorySet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  work_Caller ?: ID;
  onHold ?: Boolean;
  isActive ?: Boolean;}) => null
 
  retailerCount?: Int;
 
  assigned?: Boolean;
 
  lastCallDate?: Date;

}
 
export interface DistrictNode {

  id: ID;
 
  name: String;
 
  stateid?: QuestionnaireStateObject;
 
  townSet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  id_In ?: ID;
  name_Icontains ?: String;
  districtid_Stateid ?: ID;
  districtid_Stateid_Name_In ?: ID;}) => null

}
 
export interface QuestionnaireStateObject {

  id: ID;
 
  name?: String;
 
  code?: String;
 
  gstcode?: String;
 
  districtSet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;}) => null
 
  questionnaireSet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;}) => null
 
  assignworkSet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  supervisor ?: ID;
  caller ?: ID;
  caller_Employee_Name_Icontains ?: ID;}) => null
 
  emailsettingSet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  state ?: ID;
  isGlobal ?: Boolean;}) => null

}
 
export interface DistrictNodeConnection {

  pageInfo: PageInfo;
 
  edges: DistrictNodeEdge[];

}
 
export interface PageInfo {

  hasNextPage: Boolean;
 
  hasPreviousPage: Boolean;
 
  startCursor?: String;
 
  endCursor?: String;

}
 
export type Boolean = boolean;

   
export interface DistrictNodeEdge {

  node?: DistrictNode;
 
  cursor: String;

}
 
export interface QuestionnaireNodeConnection {

  pageInfo: PageInfo;
 
  edges: QuestionnaireNodeEdge[];

}
 
export interface QuestionnaireNodeEdge {

  node?: QuestionnaireNode;
 
  cursor: String;

}
 
export interface QuestionnaireNode {

  id: ID;
 
  name: String;
 
  state?: QuestionnaireStateObject;
 
  town?: TownNode;
 
  questions: Int[];
 
  addedBy?: UserDetailNode;
 
  active: Boolean;
 
  openingStatement?: String;
 
  closingStatement?: String;
 
  allQuestions: QuestionNode[];

}
 
export interface UserDetailNode {

  id: ID;
 
  states: JSONString[];
 
  towns: JSONString[];
 
  areas: JSONString[];
 
  employee: EmployeeNode;
 
  user?: UserNode;
 
  userType: UserDetailUserType;
 
  supervisor?: UserDetailNode;
 
  questionSet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  addedBy_Id ?: ID;
  name_Icontains ?: String;}) => null
 
  questionnaireSet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;}) => null
 
  supervisorFor: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  supervisor ?: ID;
  caller ?: ID;
  caller_Employee_Name_Icontains ?: ID;}) => null
 
  callerFor: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  supervisor ?: ID;
  caller ?: ID;
  caller_Employee_Name_Icontains ?: ID;}) => null
 
  callhistorySet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;}) => null
 
  callresponseSet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  call ?: ID;}) => null
 
  userdetailSet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;}) => null
 
  isWorkActive?: Boolean;
 
  stateList: StateNode[];
 
  townList: TownNode[];
 
  areaList: AreaNode[];
 
  totalAssignment: (params: {
  dateRange : String;}) => Int
 
  callAnswered: (params: {
  dateRange : String;}) => Int
 
  notAnswered: (params: {
  dateRange : String;}) => Int
 
  wrongNumber: (params: {
  dateRange : String;}) => Int
 
  submitWithAlert: (params: {
  dateRange : String;}) => Int

}
 
export type JSONString = undefined;

   
export interface UserNode {

  id: ID;
 
  password: String;
 
  lastLogin?: DateTime;
 
  isSuperuser: Boolean;
 
  username: String;
 
  firstName: String;
 
  lastName: String;
 
  email: String;
 
  isStaff: Boolean;
 
  isActive: Boolean;
 
  dateJoined: DateTime;
 
  userdetail?: UserDetailNode;

}
 
export type DateTime = string;

   
export enum UserDetailUserType {
  // CALLER
    CALLER = 'CALLER',// SUPERVISOR
    SUPERVISOR = 'SUPERVISOR',// ADMIN
    ADMIN = 'ADMIN'
}
   
export interface QuestionNodeConnection {

  pageInfo: PageInfo;
 
  edges: QuestionNodeEdge[];

}
 
export interface QuestionNodeEdge {

  node?: QuestionNode;
 
  cursor: String;

}
 
export interface QuestionNode {

  id: ID;
 
  questionType: QuestionQuestionType;
 
  name: String;
 
  description: String;
 
  options: String[];
 
  addedBy?: UserDetailNode;
 
  usedInQuestionnaire?: Boolean;

}
 
export enum QuestionQuestionType {
  // MULTIPLE CHOICE
    MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',// SINGLE CHOICE
    SINGLE_CHOICE = 'SINGLE_CHOICE',// TEXT
    TEXT = 'TEXT'
}
   
export interface AssignWorkNodeConnection {

  pageInfo: PageInfo;
 
  edges: AssignWorkNodeEdge[];

}
 
export interface AssignWorkNodeEdge {

  node?: AssignWorkNode;
 
  cursor: String;

}
 
export interface AssignWorkNode {

  id: ID;
 
  state: QuestionnaireStateObject;
 
  towns: TownNode[];
 
  areas: AreaNode[];
 
  supervisor: UserDetailNode;
 
  caller: UserDetailNode;
 
  deadline?: Date;
 
  dateAssigned: Date;
 
  workhistorySet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  work_Caller ?: ID;
  onHold ?: Boolean;
  isActive ?: Boolean;}) => null
 
  workStatus?: WorkStatusEnum;
 
  totalRetailersCalled?: Int;

}
 
export interface AreaNode {

  id: ID;
 
  name: String;
 
  townid?: TownNode;
 
  retailerSet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  firm_Icontains ?: String;
  townid ?: ID;
  areaid ?: ID;
  active ?: Boolean;}) => null
 
  workhistorySet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  work_Caller ?: ID;
  onHold ?: Boolean;
  isActive ?: Boolean;}) => null
 
  retailerCount?: Int;
 
  assigned?: Boolean;
 
  lastCallDate?: Date;

}
 
export interface RetailerNodeConnection {

  pageInfo: PageInfo;
 
  edges: RetailerNodeEdge[];

}
 
export interface RetailerNodeEdge {

  node?: RetailerNode;
 
  cursor: String;

}
 
export interface RetailerNode {

  id: ID;
 
  firm: String;
 
  proprietor: String;
 
  address: String;
 
  pincode: String;
 
  mobilenumber1: String;
 
  mobilenumber2: String;
 
  classField: String;
 
  approved: Boolean;
 
  townid?: TownNode;
 
  areaid?: AreaForWorkNode;
 
  geolocation?: String;
 
  addedbyid?: EmployeeNode;
 
  active: Boolean;
 
  callhistorySet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;}) => null
 
  numberInDnd: String[];

}
 
export interface AreaForWorkNode {

  id: ID;
 
  name: String;
 
  townid?: TownNode;
 
  retailerSet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  firm_Icontains ?: String;
  townid ?: ID;
  areaid ?: ID;
  active ?: Boolean;}) => null
 
  workhistorySet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  work_Caller ?: ID;
  onHold ?: Boolean;
  isActive ?: Boolean;}) => null

}
 
export interface WorkHistoryNodeConnection {

  pageInfo: PageInfo;
 
  edges: WorkHistoryNodeEdge[];

}
 
export interface WorkHistoryNodeEdge {

  node?: WorkHistoryNode;
 
  cursor: String;

}
 
export interface WorkHistoryNode {

  id: ID;
 
  work: AssignWorkNode;
 
  town?: TownNode;
 
  area?: AreaForWorkNode;
 
  startDateTime: DateTime;
 
  endDateTime?: DateTime;
 
  calls: WorkHistoryCall[];
 
  onHold: Boolean;
 
  isActive: Boolean;
 
  callhistorySet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;}) => null
 
  callresponseSet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  call ?: ID;}) => null
 
  totalCallsMade?: Int;

}
 
export interface WorkHistoryCall {

  retailer?: RetailerNode;
 
  mobileNumber?: String;
 
  callStatus?: CallStatusEnum;
 
  attempts?: Int;

}
 
export enum CallStatusEnum {
  
    ANSWERED = 'ANSWERED',
    NO_REPLY = 'NO_REPLY',
    WRONG_NUMBER = 'WRONG_NUMBER',
    REJECTED = 'REJECTED'
}
   
export interface CallHistoryNodeConnection {

  pageInfo: PageInfo;
 
  edges: CallHistoryNodeEdge[];

}
 
export interface CallHistoryNodeEdge {

  node?: CallHistoryNode;
 
  cursor: String;

}
 
export interface CallHistoryNode {

  id: ID;
 
  workHistory?: WorkHistoryNode;
 
  callStart?: DateTime;
 
  callEnd?: DateTime;
 
  retailer: RetailerNode;
 
  mobileNumber: String;
 
  callStatus: CallHistoryCallStatus;
 
  addedBy?: UserDetailNode;
 
  callresponseSet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  call ?: ID;}) => null
 
  callDate?: Date;
 
  duration?: String;

}
 
export enum CallHistoryCallStatus {
  // ANSWERED
    ANSWERED = 'ANSWERED',// NO_REPLY
    NO_REPLY = 'NO_REPLY',// WRONG_NUMBER
    WRONG_NUMBER = 'WRONG_NUMBER'
}
   
export interface CallResponseNodeConnection {

  pageInfo: PageInfo;
 
  edges: CallResponseNodeEdge[];

}
 
export interface CallResponseNodeEdge {

  node?: CallResponseNode;
 
  cursor: String;

}
 
export interface CallResponseNode {

  id: ID;
 
  workHistory?: WorkHistoryNode;
 
  call: CallHistoryNode;
 
  order: JSONString[];
 
  competitorPricing: JSONString[];
 
  remarks?: String;
 
  isAlert: Boolean;
 
  answers: JSONString[];
 
  addedBy?: UserDetailNode;
 
  question: String[];

}
 
export enum WorkStatusEnum {
  
    PENDING = 'PENDING',
    DOING = 'DOING',
    FINNISHED = 'FINNISHED',
    ON_HOLD = 'ON_HOLD'
}
   
export interface UserDetailNodeConnection {

  pageInfo: PageInfo;
 
  edges: UserDetailNodeEdge[];

}
 
export interface UserDetailNodeEdge {

  node?: UserDetailNode;
 
  cursor: String;

}
 
export interface StateNode {

  id: ID;
 
  name: String;
 
  code: String;
 
  gstcode: String;
 
  districtSet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;}) => null
 
  questionnaireSet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;}) => null
 
  assignworkSet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  supervisor ?: ID;
  caller ?: ID;
  caller_Employee_Name_Icontains ?: ID;}) => null
 
  emailsettingSet: (params: {
  before ?: String;
  after ?: String;
  first ?: Int;
  last ?: Int;
  id ?: ID;
  state ?: ID;
  isGlobal ?: Boolean;}) => null

}
 
export interface EmailSettingNodeConnection {

  pageInfo: PageInfo;
 
  edges: EmailSettingNodeEdge[];

}
 
export interface EmailSettingNodeEdge {

  node?: EmailSettingNode;
 
  cursor: String;

}
 
export interface EmailSettingNode {

  id: ID;
 
  employee: EmployeeNode;
 
  state?: QuestionnaireStateObject;
 
  isGlobal: Boolean;

}
 
export interface TownNodeConnection {

  pageInfo: PageInfo;
 
  edges: TownNodeEdge[];

}
 
export interface TownNodeEdge {

  node?: TownNode;
 
  cursor: String;

}
 
export interface AreaForWorkNodeConnection {

  pageInfo: PageInfo;
 
  edges: AreaForWorkNodeEdge[];

}
 
export interface AreaForWorkNodeEdge {

  node?: AreaForWorkNode;
 
  cursor: String;

}
 
export interface EmployeeNodeConnection {

  pageInfo: PageInfo;
 
  edges: EmployeeNodeEdge[];

}
 
export interface EmployeeNodeEdge {

  node?: EmployeeNode;
 
  cursor: String;

}
 
export interface StateNodeConnection {

  pageInfo: PageInfo;
 
  edges: StateNodeEdge[];

}
 
export interface StateNodeEdge {

  node?: StateNode;
 
  cursor: String;

}
 
export interface AreaNodeConnection {

  pageInfo: PageInfo;
 
  edges: AreaNodeEdge[];

}
 
export interface AreaNodeEdge {

  node?: AreaNode;
 
  cursor: String;

}
 
export interface ProductNodeConnection {

  pageInfo: PageInfo;
 
  edges: ProductNodeEdge[];

}
 
export interface ProductNodeEdge {

  node?: ProductNode;
 
  cursor: String;

}
 
export interface ProductNode {

  id: ID;
 
  name: String;
 
  code: String;
 
  content: Int;
 
  currentcasesize: Int;
 
  packagingcharges: Int;
 
  baseformrp: Boolean;
 
  mrpround?: String;
 
  baseforrate: Boolean;
 
  rateround?: String;
 
  formulaformrp: String;
 
  formulaforrate: String;
 
  sorting?: Int;
 
  defaultmrp: Float;
 
  defaultrate: Float;

}
 
export type Float = number;

   
export interface QuestionnaireStateObjectConnection {

  pageInfo: PageInfo;
 
  edges: QuestionnaireStateObjectEdge[];

}
 
export interface QuestionnaireStateObjectEdge {

  node?: QuestionnaireStateObject;
 
  cursor: String;

}
 
export interface UserNodeConnection {

  pageInfo: PageInfo;
 
  edges: UserNodeEdge[];

}
 
export interface UserNodeEdge {

  node?: UserNode;
 
  cursor: String;

}
 
export interface Mutation {

  createDnd: (params: {
  input : DndMutationInput;}) => DndMutationPayload
 
  createSync: (params: {
  input : SyncMutationInput;}) => SyncMutationPayload
 
  createRetailerForApproval: (params: {
  input : RetailerForApprovalMutationInput;}) => RetailerForApprovalMutationPayload
 
  createUserDetail: (params: {
  input : UserDetailMutationInput;}) => UserDetailMutationPayload
 
  createEmailSetting: (params: {
  input : EmailSettingMutationInput;}) => EmailSettingMutationPayload
 
  createCallHistory: (params: {
  input : CallHistoryMutationInput;}) => CallHistoryMutationPayload
 
  createCallResponse: (params: {
  input : CallResponseMutationInput;}) => CallResponseMutationPayload
 
  createAssignwork: (params: {
  input : AssignWorkMutationInput;}) => AssignWorkMutationPayload
 
  createWorkHistory: (params: {
  input : WorkHistoryMutationInput;}) => WorkHistoryMutationPayload
 
  createQuestionnaire: (params: {
  input : QuestionnaireMutationInput;}) => QuestionnaireMutationPayload
 
  createQuestion: (params: {
  input : QuestionMutationInput;}) => QuestionMutationPayload

}
 
export interface DndMutationPayload {

  id?: ID;
 
  phonenumber?: String;
 
  createdat?: DateTime;
 
  addedbyid?: String;
 
  errors: ErrorType[];
 
  clientMutationId?: String;

}
 
export interface ErrorType {

  field: String;
 
  messages: null[];

}
 export interface DndMutationInput {
  id ?: ID;
  phonenumber ?: String;
  createdat : DateTime;
  addedbyid ?: String;
  clientMutationId ?: String;} 
export interface SyncMutationPayload {

  id?: ID;
 
  distributordata?: String;
 
  retailerdata?: String;
 
  lastsynctime?: DateTime;
 
  islocationallowed?: Boolean;
 
  employeeid?: String;
 
  errors: ErrorType[];
 
  clientMutationId?: String;

}
 export interface SyncMutationInput {
  id ?: ID;
  distributordata ?: String;
  retailerdata ?: String;
  lastsynctime ?: DateTime;
  islocationallowed ?: Boolean;
  employeeid ?: String;
  clientMutationId ?: String;} 
export interface RetailerForApprovalMutationPayload {

  id?: ID;
 
  createdat?: DateTime;
 
  changeddata?: String;
 
  retailerid?: String;
 
  employeeid?: String;
 
  errors: ErrorType[];
 
  clientMutationId?: String;

}
 export interface RetailerForApprovalMutationInput {
  id ?: ID;
  createdat ?: DateTime;
  changeddata ?: String;
  retailerid ?: String;
  employeeid ?: String;
  clientMutationId ?: String;} 
export interface UserDetailMutationPayload {

  id?: ID;
 
  states: JSONString[];
 
  towns: JSONString[];
 
  areas: JSONString[];
 
  userType?: String;
 
  employee?: String;
 
  supervisor?: String;
 
  errors: ErrorType[];
 
  clientMutationId?: String;

}
 export interface UserDetailMutationInput {
  id ?: ID;
  username : String;
  password : String;
  states : JSONString[];
  towns : JSONString[];
  areas : JSONString[];
  userType : String;
  employee : String;
  supervisor ?: String;
  clientMutationId ?: String;} 
export interface EmailSettingMutationPayload {

  id?: ID;
 
  isGlobal?: Boolean;
 
  employee?: String;
 
  state?: String;
 
  errors: ErrorType[];
 
  clientMutationId?: String;

}
 export interface EmailSettingMutationInput {
  id ?: ID;
  isGlobal ?: Boolean;
  employee : String;
  state ?: String;
  clientMutationId ?: String;} 
export interface CallHistoryMutationPayload {

  id?: ID;
 
  callStart?: DateTime;
 
  callEnd?: DateTime;
 
  mobileNumber?: String;
 
  callStatus?: String;
 
  workHistory?: String;
 
  retailer?: String;
 
  addedBy?: String;
 
  errors: ErrorType[];
 
  clientMutationId?: String;

}
 export interface CallHistoryMutationInput {
  id ?: ID;
  toCloseRetailer ?: String;
  callStart ?: DateTime;
  callEnd ?: DateTime;
  mobileNumber : String;
  callStatus : String;
  workHistory ?: String;
  retailer : String;
  addedBy ?: String;
  clientMutationId ?: String;} 
export interface CallResponseMutationPayload {

  id?: ID;
 
  order: JSONString[];
 
  competitorPricing: JSONString[];
 
  remarks?: String;
 
  isAlert?: Boolean;
 
  answers: JSONString[];
 
  workHistory?: String;
 
  call?: String;
 
  addedBy?: String;
 
  errors: ErrorType[];
 
  clientMutationId?: String;

}
 export interface CallResponseMutationInput {
  id ?: ID;
  order : JSONString[];
  competitorPricing : JSONString[];
  remarks ?: String;
  isAlert ?: Boolean;
  answers : JSONString[];
  workHistory ?: String;
  call : String;
  addedBy ?: String;
  clientMutationId ?: String;} 
export interface AssignWorkMutationPayload {

  id?: ID;
 
  towns: Int[];
 
  areas: Int[];
 
  deadline?: Date;
 
  dateAssigned?: Date;
 
  state?: String;
 
  supervisor?: String;
 
  caller?: String;
 
  errors: ErrorType[];
 
  clientMutationId?: String;

}
 export interface AssignWorkMutationInput {
  id ?: ID;
  towns : Int[];
  areas : Int[];
  deadline ?: Date;
  dateAssigned ?: Date;
  state : String;
  supervisor : String;
  caller : String;
  clientMutationId ?: String;} 
export interface WorkHistoryMutationPayload {

  id?: ID;
 
  startDateTime?: DateTime;
 
  endDateTime?: DateTime;
 
  calls: JSONString[];
 
  onHold?: Boolean;
 
  isActive?: Boolean;
 
  work?: String;
 
  town?: String;
 
  area?: String;
 
  errors: ErrorType[];
 
  clientMutationId?: String;

}
 export interface WorkHistoryMutationInput {
  id ?: ID;
  startDateTime ?: DateTime;
  endDateTime ?: DateTime;
  calls : JSONString[];
  onHold ?: Boolean;
  isActive ?: Boolean;
  work : String;
  town ?: String;
  area ?: String;
  clientMutationId ?: String;} 
export interface QuestionnaireMutationPayload {

  id?: ID;
 
  name?: String;
 
  questions: Int[];
 
  active?: Boolean;
 
  openingStatement?: String;
 
  closingStatement?: String;
 
  state?: String;
 
  town?: String;
 
  addedBy?: String;
 
  errors: ErrorType[];
 
  clientMutationId?: String;

}
 export interface QuestionnaireMutationInput {
  id ?: ID;
  name : String;
  questions : Int[];
  active ?: Boolean;
  openingStatement ?: String;
  closingStatement ?: String;
  state ?: String;
  town ?: String;
  addedBy ?: String;
  clientMutationId ?: String;} 
export interface QuestionMutationPayload {

  question?: QuestionNode;
 
  errors: ErrorType[];
 
  clientMutationId?: String;

}
 export interface QuestionMutationInput {
  questionType : String;
  name : String;
  description : String;
  options ?: String;
  addedBy ?: ID;
  id ?: ID;
  clientMutationId ?: String;} 
export interface __Schema {

  types: null[];
 
  queryType: __Type;
 
  mutationType?: __Type;
 
  subscriptionType?: __Type;
 
  directives: null[];

}
 
export interface __Type {

  kind: __TypeKind;
 
  name?: String;
 
  description?: String;
 
  fields: (params: {
  includeDeprecated ?: Boolean;}) => null
 
  interfaces: null[];
 
  possibleTypes: null[];
 
  enumValues: (params: {
  includeDeprecated ?: Boolean;}) => null
 
  inputFields: null[];
 
  ofType?: __Type;

}
 
export enum __TypeKind {
  // Indicates this type is a scalar.
    SCALAR = 'SCALAR',// Indicates this type is an object. `fields` and `interfaces` are valid fields.
    OBJECT = 'OBJECT',// Indicates this type is an interface. `fields` and `possibleTypes` are valid fields.
    INTERFACE = 'INTERFACE',// Indicates this type is a union. `possibleTypes` is a valid field.
    UNION = 'UNION',// Indicates this type is an enum. `enumValues` is a valid field.
    ENUM = 'ENUM',// Indicates this type is an input object. `inputFields` is a valid field.
    INPUT_OBJECT = 'INPUT_OBJECT',// Indicates this type is a list. `ofType` is a valid field.
    LIST = 'LIST',// Indicates this type is a non-null. `ofType` is a valid field.
    NON_NULL = 'NON_NULL'
}
   
export interface __Field {

  name: String;
 
  description?: String;
 
  args: null[];
 
  type: __Type;
 
  isDeprecated: Boolean;
 
  deprecationReason?: String;

}
 
export interface __InputValue {

  name: String;
 
  description?: String;
 
  type: __Type;
 
  defaultValue?: String;

}
 
export interface __EnumValue {

  name: String;
 
  description?: String;
 
  isDeprecated: Boolean;
 
  deprecationReason?: String;

}
 
export interface __Directive {

  name: String;
 
  description?: String;
 
  locations: null[];
 
  args: null[];
 
  onOperation: Boolean;
 
  onFragment: Boolean;
 
  onField: Boolean;

}
 
export enum __DirectiveLocation {
  // Location adjacent to a query operation.
    QUERY = 'QUERY',// Location adjacent to a mutation operation.
    MUTATION = 'MUTATION',// Location adjacent to a subscription operation.
    SUBSCRIPTION = 'SUBSCRIPTION',// Location adjacent to a field.
    FIELD = 'FIELD',// Location adjacent to a fragment definition.
    FRAGMENT_DEFINITION = 'FRAGMENT_DEFINITION',// Location adjacent to a fragment spread.
    FRAGMENT_SPREAD = 'FRAGMENT_SPREAD',// Location adjacent to an inline fragment.
    INLINE_FRAGMENT = 'INLINE_FRAGMENT',// Location adjacent to a schema definition.
    SCHEMA = 'SCHEMA',// Location adjacent to a scalar definition.
    SCALAR = 'SCALAR',// Location adjacent to an object definition.
    OBJECT = 'OBJECT',// Location adjacent to a field definition.
    FIELD_DEFINITION = 'FIELD_DEFINITION',// Location adjacent to an argument definition.
    ARGUMENT_DEFINITION = 'ARGUMENT_DEFINITION',// Location adjacent to an interface definition.
    INTERFACE = 'INTERFACE',// Location adjacent to a union definition.
    UNION = 'UNION',// Location adjacent to an enum definition.
    ENUM = 'ENUM',// Location adjacent to an enum value definition.
    ENUM_VALUE = 'ENUM_VALUE',// Location adjacent to an input object definition.
    INPUT_OBJECT = 'INPUT_OBJECT',// Location adjacent to an input object field definition.
    INPUT_FIELD_DEFINITION = 'INPUT_FIELD_DEFINITION'
}
  
